import React, { useState } from "react";
import RightArrow from "images/arrow-right.png";
import RichText from "components/rich-text";
import Modal from "components/modal";

const Introduction = ({ data }) => {
  const { title, description, handbook, handbookurl } = data;

  const [modalShow, setModalShow] = useState(false);

  const components = {
    normal: ({ children }) => (
      <p className="paragraph-normal text-gray-800 sm:text-base leading-7 mb-5">
        {children}
      </p>
    ),
    h2: ({ children }) => (
      <h2 className="header mt-14 mb-6 sm:text-2xl !text-gray-800">
        {children}
      </h2>
    ),
    h3: ({ children }) => (
      <h2 className="text-h3 font-bold mt-11 mb-8 sm:text-xl text-gray-800">
        {children}
      </h2>
    ),
  };

  return (
    <div>
      <h2 className="font-display font-bold text-h2 text-green-800 mb-8">
        {title}
      </h2>
      <div className="paragraph-normal text-gray-800">
        <RichText value={description.data} components={components} />
      </div>
      {handbook && (
        <div className="mt-5 flex items-center justify-start gap-6 sm:flex-col sm:items-start">
          <p className="paragraph text-gray-800">Want to learn more?</p>
          <button
            className="btn btn-primary"
            onClick={() => setModalShow(true)}
          >
            View the handbook
            <img src={RightArrow} alt="right arrow" className="w-6 h-6" />
          </button>
        </div>
      )}

      {modalShow && (
        <Modal isOpen={modalShow} onClose={() => setModalShow(false)}>
          <object
            width="100%"
            height="100%"
            data={handbookurl}
            type="application/pdf"
          ></object>
        </Modal>
      )}

      <div className="h-px w-full bg-gray-300 my-8" />
    </div>
  );
};

export default Introduction;
